<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("Schedule Event/Activities") }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-2"
          outlined
          dark
          @click="$router.push({ name: 'ActionListCal' })"
          >{{ $t("calendar View") }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          dark
          @click="$router.push({ name: 'CreateTask' })"
          >{{ $t("Add New") }}
        </v-btn>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <template>
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab @click="changeTaskStatusType('upcoming')">
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" plain text>
                      {{ $t("Upcoming") }}({{
                        tasksCount ? tasksCount.upcoming : 0
                      }})
                    </v-btn>
                  </template>
                  <span
                    >List of events/activities yet to be started in the
                    future</span
                  >
                </v-tooltip>
              </v-tab>
              <v-tab @click="changeTaskStatusType('completed')">
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn plain text v-bind="attrs" v-on="on">
                      {{ $t("Completed") }} ({{
                        tasksCount ? tasksCount.completed : 0
                      }})
                    </v-btn>
                  </template>
                  <span>List of completed events/activities</span>
                </v-tooltip>
              </v-tab>
            </v-tabs>
          </template>

          <v-data-table
            :headers="headers"
            :items="tasks"
            :items-per-page="10"
            v-model="selected"
            show-select
            :loading="$apollo.loading"
            loading-text="Loading Users... Please wait"
            :footer-props="{
              'items-per-page-options': [10, 25, 50],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Users per page',
            }"
            :options.sync="options"
            hide-default-footer
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search"
                  dense
                  v-model="search"
                  @click:append="searchUsers"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="selected.length === 0"
                  outlined
                  class="mr-8"
                  @click="startBulkDelete"
                >
                  {{ $t("Bulk Delete") }}
                </v-btn>
                <div class="py-1 title">
                  {{ from }} - {{ to }} {{ $t('of') }} {{ totalTasks }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="options.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="options.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data v-if="!tasks || tasks.length < 1">
              {{ $t('actionListmod.noTaskAvailable') }}
            </template>

            <template v-if="tasks && tasks.length > 0" v-slot:body>
              <tbody>
                <tr
                  v-for="item in tasks"
                  :key="item.id"
                  style="position: relative; width: 0; height: 0"
                >
                  <td :key="`checkbox-${item.id}`">
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.module?.name }}</td>
                  <td>
                    {{
                      animalInfo(item.taskForAnimals, item.taskForAnimalGroups)
                    }}
                  </td>
                  <td>{{ formatDate(item.start) }}</td>
                  <td>{{ formatDate(item.end) }}</td>
                  <td>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          dark
                          v-bind="attrs"
                          v-on="on"
                          :style="{
                            display: 'flex',
                            width: '120px',
                            padding: '8px',
                            'font-size': '13px',
                            'justify-content': 'center',
                            'border-radius': '50px',
                            background: background(item.status),
                            border: border(item.status),
                            color: color(item.status),
                          }"
                        >
                          {{ item.status }}
                          <!-- <v-icon>mdi-arrow-down</v-icon> -->
                          <v-icon>mdi-chevron-down</v-icon>
                        </div>
                      </template>
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-card
                            v-if="
                              new Date(item.start).getDate() <
                              new Date().getDate()
                            "
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-list>
                              <v-list-item
                                :style="{
                                  cursor: 'pointer',
                                }"
                                :disabled="
                                  new Date(item.start).getDate() <
                                  new Date().getDate()
                                    ? true
                                    : false
                                "
                                v-for="(stat, index) in statusList"
                                :key="index"
                              >
                                <v-list-item-title
                                  @click="changeStatus(stat, item)"
                                  >{{ stat }}</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-card>
                          <v-card v-else>
                            <v-list>
                              <v-list-item
                                :style="{
                                  cursor: 'pointer',
                                }"
                                :disabled="
                                  new Date(item.start).getDate() <
                                  new Date().getDate()
                                    ? true
                                    : false
                                "
                                v-for="(stat, index) in statusList"
                                :key="index"
                              >
                                <v-list-item-title
                                  @click="changeStatus(stat, item)"
                                  >{{ stat }}</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </template>
                        <span
                          >Status for events in the past cannot be changed
                        </span>
                      </v-tooltip>
                    </v-menu>
                  </td>
                  <td>{{ item.priority }}</td>                  
                  <td>
                    <v-toolbar flat width="100%">
                      <v-icon
                        dark
                        color="gray"
                        @click="
                          $router.push({
                            name: 'UpdateTask',
                            params: { task_id: item.id },
                          })
                        "
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon dark color="red" @click="startDelete(item)">
                        mdi-delete
                      </v-icon>
                    </v-toolbar>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog
        v-model="showDeleteConfirm"
        transition="dialog-top-transition"
        max-width="500"
        persistent
      >
        <template>
          <v-card rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t('warning') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="
                  showDeleteConfirm = false;
                  deleteItem = null;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="gray--text py-10" style="font-size: 16px">
              <h2>{{ $t('mySchdl.areYouSure') }}</h2>
              <p class="mt-4">{{ $t('mySchdl.areYouSureMsg1') }}</p>
              <p>{{ $t('mySchdl.areYouSureMsg2') }}</p>
              <!--<p>Your previous records might get affected.</p>-->
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="px-4 py-5 justify-center">
              <div>
                <v-spacer></v-spacer>
                <v-btn
                  @click="
                    showDeleteConfirm = false;
                    deleteItem = null;
                  "
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  @click="deleteTask"
                  right
                  height="44"
                  color="error"
                  class="px-5"
                >
                  {{ $t("delete") }}
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import { tasksCount, tasks, updateTaskStatus } from "@/graphql/ActionLists.gql";
import gql from "graphql-tag";

export default {
  apollo: {
    tasks: {
      query: tasks,
      fetchPolicy: "network-only",
      variables() {
        return {
          type: this.showStatusType,
          page: this.options.page,
          limit: this.options.itemsPerPage,
          search: this.search,
        };
      },
      update: data => data.tasks.rows,
      result({ data }) {
        console.log("dlsfjdklf", data);
        this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;

        this.to =
          this.options.page * this.options.itemsPerPage -
          (this.options.itemsPerPage - data.tasks.count);
        this.totalTasks = data.tasks.totalCount;
      },
    },
    tasksCount: {
      query: tasksCount,
      fetchPolicy: "network-only",
    },
  },
  mounted() {
    document.title = this.$t('mySchedule');
  },
  created() {
    // if (this.checkBreakPoints) this.tabletGetDailyTasks();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  methods: {
    async startDelete(item) {
      this.showDeleteConfirm = true;
      this.deleteItem = [item];
    },
    async startBulkDelete() {
      this.showDeleteConfirm = true;
      this.deleteItem = this.selected;
    },
    async deleteTask() {
      if (!this.deleteItem) {
        alert(this.$t('mySchdl.noDiseaseDelete'));
        return;
      }

      let items = this.deleteItem.map(item => parseInt(item.id));
      //this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($id: [Int!]!) {
              deleteTask(ids: $id) {
                success
              }
            }
          `,
          // Parameters
          variables: {
            id: items,
          },
        })
        .then(async response => {
          this.$notify({
            title: this.$t('mySchdl.taskDeletedSuccessfully'),
            text: response.message,
            type: "success",
            position: "top right",
          });

          this.showDeleteConfirm = false;
          this.deleteItem = null;
          this.$apollo.queries.tasksCount.refetch();
          this.$apollo.queries.tasks.refetch();
          //this.stopLoading();
        })
        .catch(async error => {
          console.log(error);
          this.showDeleteConfirm = false;
          this.deleteItem = null;
          //this.stopLoading();
        });
      console.log("delete disease");
    },

    background(status) {
      if (status == "Canceled") {
        return this.canceledLight;
      } else if (status == "To-Do") {
        return this.todoLight;
      } else if (status == "Pending") {
        return this.pendingLight;
      } else if (status == "Completed") {
        return this.completedLight;
      }
    },
    border(status) {
      if (status == "Canceled") {
        return `1px solid ${this.canceledDark}`;
      } else if (status == "To-Do") {
        return `1px solid ${this.todoDark}`;
      } else if (status == "Pending") {
        return `1px solid ${this.pendingDark}`;
      } else if (status == "Completed") {
        return `1px solid ${this.completedDark}`;
      }
    },
    color(status) {
      if (status == "Canceled") {
        return this.canceledDark;
      } else if (status == "To-Do") {
        return this.todoDark;
      } else if (status == "Pending") {
        return this.pendingDark;
      } else if (status == "Completed") {
        return this.completedDark;
      }
    },

    changeStatus(status, item) {
      this.$apollo
        .mutate({
          mutation: updateTaskStatus,
          variables: {
            updateTaskStatusInput: { id: parseInt(item.id), status: status },
          },
        })
        .then(res => {
          console.log(res);
          this.$apollo.queries.tasksCount.refetch();
          this.$apollo.queries.tasks.refetch();
          this.$apollo.queries.tasksCount.refetch();
          this.$notify({
            title: this.$t('mySchdl.taskStatusUpdatedSuccessfully'),
            text: this.$t('mySchdl.taskStatusUpdatedSuccessfully'),
            type: "success",
          });
        })
        .catch(err => {
          console.log("err", err.response);
        });
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    // getDailyTasks() {
    //   this.loading = true;
    //   this.$store
    //     .dispatch("getDailyTasks", this.options, "completed")
    //     .then((res) => {
    //       console.log("tbl", res);
    //       if (res.success) {
    //         this.items = res.data.task.rows;
    //         this.totalTasks = res.data.task.total_rows;
    //         this.totalPages = Math.ceil(
    //           this.totalTasks / this.options.itemsPerPage
    //         );
    //         this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
    //         this.to =
    //           this.options.page * this.options.itemsPerPage -
    //           (this.options.itemsPerPage - res.data.task.num_rows);
    //         this.loading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       //     this.items = []
    //       console.log(err);
    //       //     // if(err.response.status == 403)
    //       //         // this.$router.go(-1)
    //     });
    // },
    // tabletGetDailyTasks() {
    //   this.loading = true;
    //   this.$store
    //     .dispatch("getDailyTasks", this.tabletTableOptions, "completed")
    //     .then((res) => {
    //       console.log("tbl", res);
    //       if (res.success) {
    //         this.items = res.data.task.rows;
    //         this.totalTasks = res.data.task.total_rows;
    //         this.totalPages = Math.ceil(
    //           this.totalTasks / this.tabletTableOptions.itemsPerPage
    //         );
    //         this.from =
    //           (this.tabletTableOptions.page - 1) *
    //             this.tabletTableOptions.itemsPerPage +
    //           1;
    //         this.to =
    //           this.tabletTableOptions.page *
    //             this.tabletTableOptions.itemsPerPage -
    //           (this.tabletTableOptions.itemsPerPage - res.data.task.num_rows);
    //         this.loading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       //     this.items = []
    //       console.log(err);
    //       //     // if(err.response.status == 403)
    //       //         // this.$router.go(-1)
    //     });
    // },

    changeTaskStatusType(type) {
      if (this.showStatusType == type) return;
      this.showStatusType = type;
      this.options.page = 1;
      this.$apollo.queries.tasksCount.refetch();
      this.$apollo.queries.tasks.refetch();
    },

    searchUsers() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.tabletGetDailyTasks();
      } else {
        this.options.page = 1;
        // this.getDailyTasks();
      }
    },

    resetSearchOnEmpty() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.tabletGetDailyTasks();
      } else {
        this.options.page = 1;
        // this.getDailyTasks();
      }
    },

    getTaskData() {
      // this.getDailyTasks();
    },

    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      // this.getTaskData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      // this.tabletGetDailyTasks();
    },
    animalInfo(animals = [], groups = []) {
      const A = [];
      const G = [];
      if (animals?.length) {
        animals.forEach(e => {
          A.push(parseInt(e.id));
        });
      }
      if (groups?.length) {
        groups.forEach(e => {
          G.push(e.name);
        });
      }
      let animalInfo = A.toString();
      if (G.toString() && G.toString() != "") {
        animalInfo = animalInfo + " - " + G.toString();
      }
      return animalInfo;
    },
  },
  data() {
    return {
      deleteItem: null,
      showDeleteConfirm: false,

      completedLight: "#E5F8F1",
      completedDark: "#00BD73",

      canceledLight: "#FDEBEB",
      canceledDark: "#F03737",

      todoLight: "#E8E8E8",
      todoDark: "#000000",

      pendingLight: "#FFF0D9",
      pendingDark: "#FFB443",

      statusList: ["To-Do", "Pending", "Completed", "Canceled"],
      importKey: 1,
      tab: 0,
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      pageCount: 0,
      transition: true,
      activeUsers: 0,
      deactiveUsers: 0,
      totalTasks: 0,
      importedUsers: 0,
      options: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      showStatusType: "upcoming",
      search: "",
      selected: [],
      items: [],
      selectedItem: false,
      loading: false,
      loadingText: this.$t('loadingPleaseWait'),
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("My Schedule"),
          disabled: true,
        },
      ],
      headers: [
        {
          text: this.$t("Title"),
          value: "title",
          sortable: false,
          class: "black--text text-capitalize",
        },
        {
          text: this.$t("Type"),
          value: "title",
          class: "black--text",
        },
        {
          text: this.$t("Animal(s)"),
          value: "EventActivity",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("Start Date"),
          value: "startDate",
          sortable: false,
          class: "black--text text-capitalize",
        },
        {
          text: this.$t("End Date"),
          value: "endDate",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("Status"),
          value: "status",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("Priority"),
          value: "priority",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("Actions"),
          value: "action",
          class: "black--text",
        },
      ],
    };
  },
  mixins: [loadingMixin, generalMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}

::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}

::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}

.flex-center {
  display: flex;
  align-items: center;
  //   justify-content: center;
}
</style>
